import { fetchNotificationApp } from 'store/fetchActions/fetchApp';
import { ALERTA, MSG_TAMANHO_CAMPO } from 'utils/consts';

export const handleOnChange = (event, editor, setMensagemHtml, handleChange, nameInput) => {
  const stringHtml = editor.getData();
  if (stringHtml?.length <= 2000) {
    setMensagemHtml(stringHtml);
    handleChange({ target: { name: nameInput, value: editor.getData() } });
    return editor.getData();
  } else {
    fetchNotificationApp(MSG_TAMANHO_CAMPO, '', ALERTA.ERRO, 'bottomRight', 5, null);
    return MSG_TAMANHO_CAMPO;
  }
};
